import React from 'react';
// No need for useNavigate since you're linking externally.
import styles from './OverlayLink.module.css';

// Define an interface for the component props
interface OverlayLinkProps {
  title: string;
  link: string;
  text: string;
  imageSrc: string;
  style?: React.CSSProperties; // Make style optional
}

const OverlayLink: React.FC<OverlayLinkProps> = ({ title, link, text, imageSrc, style = {} }) => {
  // Removed navigate-related code since we're using <a> for external links.

  // Merge styles with backgroundImage
  const overlayStyle = {
    ...style, // Use provided styles
    backgroundImage: `url(${imageSrc})`, // Add backgroundImage using imageSrc
  };

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.overlay}
      style={overlayStyle}
    >
      <h2>{title}</h2>
      <p>{text}</p>
    </a>
  );
};

export default OverlayLink;



